import { useLiveStreamAppContext } from "../ContextStore/Store";
import { appInsightTrack } from "../utils/AppInsights";

const DataChanneling = () => {
  const { chatThreadClientRef, communicationUserId, __merchantId, __userId } =
    useLiveStreamAppContext();

  // function to sent the secret messege in the meeting for controlling mic /video/ chat
  function sendActionToAttendee(ToACSUserId, actionType) {
    const chatThreadClient = chatThreadClientRef?.current;

    if (!chatThreadClient || typeof chatThreadClient.sendMessage !== "function") {
      console.warn("Chat thread client is not ready. Cannot send message.");
      appInsightTrack(
            __merchantId,
            __userId,
            "Error sendMessage",
            "",
            "Chat thread client is not ready. Cannot send message."
          );
      return;
    }

    if (ToACSUserId === "ALL") {
      chatThreadClient.sendMessage({
        content: "",
        metadata: {
          senderUserId: communicationUserId.communicationUserId,
          targetUserId: "",
          customType: actionType,
        },
      });
    } else {
      (async () => {
        try {
          await chatThreadClient.sendMessage({
            content: "",
            metadata: {
              senderUserId: communicationUserId.communicationUserId,
              targetUserId: ToACSUserId, // Optional metadata if needed
              customType: actionType,
            },
          });
        } catch (error) {
          console.error("Error sending message:", error);
          appInsightTrack(
            __merchantId,
            __userId,
            "Error sendMessage",
            "",
            error
          );
        }
      })(); // Immediately invoke the async function
    }
  }
  return { sendActionToAttendee };
};

export default DataChanneling;
